<main
  [style.zIndex]="index"
  style="position: fixed; top: 0; right: 0; bottom: 0"
  [hidden]="isComponentHidden"
>
  <kendo-drawer-container>
    <kendo-drawer
      style="height: 100vh"
      [width]="drawerWidth"
      #drawer
      [mode]="'overlay'"
      [position]="'end'"
      [expanded]="false"
      [autoCollapse]="false"
      [animation]="animationOptions"
      appClickOutsideDrawer
      (clickedOutside)="closeSideDrawer()"
    >
      <ng-template kendoDrawerTemplate>
        <main>
          <div>
            <div class="drawer-bar">
              <div class="drawer-sub-header">
                <app-breadcrumb
                  [elements]="[
                    { text: ('linkExistingExpense' | translate), title: '' }
                  ]"
                ></app-breadcrumb>
              </div>
            </div>
          </div>

          <div class="content-container px-4">
            <kendo-grid
              [data]="gridView"
              [loading]="isLoading"
              [pageSize]="pageSize"
              [skip]="skip"
              [sortable]="false"
              [pageable]="true"
              [selectable]="{ mode: 'single' }"
              kendoGridSelectBy="uid"
              [selectedKeys]="selectedKeys"
              (selectedKeysChange)="onSelectedKeysChange($event)"
              (dataStateChange)="onDataStateChange($event)"
              class="mt-3 expense-link-grid"
            >
              <kendo-grid-column
                [width]="120"
                field="reference"
                [title]="'reference' | translate"
              >
              </kendo-grid-column>
              <kendo-grid-column
                [width]="120"
                field="date"
                [title]="'date' | translate"
              >
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.date | customDate }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column
                [width]="150"
                field="vendor.fullName"
                [title]="'vendor' | translate"
              >
              </kendo-grid-column>
              <kendo-grid-column
                [width]="150"
                field="totalNetAmount"
                [title]="'total' | translate"
                class="text-end"
              >
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="flex justify-end">
                    @if (dataItem?.totalNetAmount != null) {
                      <app-currency-total
                        [currencyUid]="dataItem.currency?.uid"
                        [totalAmount]="dataItem.totalNetAmount"
                      ></app-currency-total>
                    }
                  </div>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column
                [width]="250"
                field="paymentAccount.fullName"
                [title]="'paymentAccount' | translate"
              >
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.paymentAccount?.fullName }}
                </ng-template>
              </kendo-grid-column>

              <ng-template kendoGridNoRecordsTemplate>
                <div class="loadingContainer">
                  <div class="recordMessage">
                    {{
                      isLoading
                        ? ("loadingMessage" | translate)
                        : ("noUnlinkedExpenses" | translate)
                    }}
                  </div>
                </div>
              </ng-template>
            </kendo-grid>
          </div>

          <app-action-bar
            [isBoxShadow]="false"
            [isWaiting]="isWaiting"
            [screenType]="'Form'"
            [actionsOptions]="[
              {
                visible: true,
                class: 'btn-primary',
                label: 'Link',
                labelName: ('link' | translate),
                disabled: !selectedExpense
              },
              {
                visible: true,
                class: 'btn-outline-secondary',
                label: 'Discard',
                labelName: ('discard' | translate)
              }
            ]"
            (buttonClick)="onActionClick($event)"
          >
          </app-action-bar>
        </main>
      </ng-template>
    </kendo-drawer>
  </kendo-drawer-container>
</main>
